/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/familyIdentityTheftMonitoringSubscriptionMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a FamilyIdentityTheftMonitoringSubscription. */
export class FamilyIdentityTheftMonitoringSubscription {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a FamilyIdentityTheftMonitoringSubscription.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls external APIs to register a subscription for the user.
   * @summary Registers a subscriber for the user based on the csid
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterSubscriberResponse>
   */
  registerSubscriber(csid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterSubscriberResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  registerSubscriber(csid: string, callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  registerSubscriber(csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  registerSubscriber(csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>, callback?: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterSubscriberResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      registerSubscriberOperationSpec,
      callback) as Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterSubscriberResponse>;
  }

  /**
   * Calls external APIs to delete the subscriber.
   * @summary Deletes the subscription for the requested member(csid)
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteSubscriber(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionDeleteSubscriberOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  deleteSubscriber(csid: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteSubscriber(csid: string, options: Models.FamilyIdentityTheftMonitoringSubscriptionDeleteSubscriberOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  deleteSubscriber(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionDeleteSubscriberOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      deleteSubscriberOperationSpec,
      callback);
  }

  /**
   * Calls external APIs to register a credit monitoring subscriber for the user.
   * @summary Registers a credit monitoring subscriber for the ITM user based on the csid.
   * @param csid
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterCreditMonitoringSubscriberResponse>
   */
  registerCreditMonitoringSubscriber(csid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterCreditMonitoringSubscriberResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  registerCreditMonitoringSubscriber(csid: string, callback: coreHttp.ServiceCallback<Models.RegisterCreditMonitoringSubscriberApiResponse>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  registerCreditMonitoringSubscriber(csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.RegisterCreditMonitoringSubscriberApiResponse>): void;
  registerCreditMonitoringSubscriber(csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.RegisterCreditMonitoringSubscriberApiResponse>, callback?: coreHttp.ServiceCallback<Models.RegisterCreditMonitoringSubscriberApiResponse>): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterCreditMonitoringSubscriberResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      registerCreditMonitoringSubscriberOperationSpec,
      callback) as Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterCreditMonitoringSubscriberResponse>;
  }

  /**
   * Calls external APIs to register a subscription for the user.
   * @summary Registers a user based on the information provided.
   * @param csid
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataResponse>
   */
  registerSubscriberWithPrimaryData(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataOptionalParams): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  registerSubscriberWithPrimaryData(csid: string, callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  registerSubscriberWithPrimaryData(csid: string, options: Models.FamilyIdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataOptionalParams, callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  registerSubscriberWithPrimaryData(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataOptionalParams | coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>, callback?: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      registerSubscriberWithPrimaryDataOperationSpec,
      callback) as Promise<Models.FamilyIdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataResponse>;
  }

  /**
   * Signal to the backend that the user has completed the onboarding process and has viewed the
   * breach result.
   * @summary Signal that the user has completed the onboarding process.
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  onboardingCompleted(csid: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  onboardingCompleted(csid: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  onboardingCompleted(csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  onboardingCompleted(csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      onboardingCompletedOperationSpec,
      callback);
  }

  /**
   * Calls external APIs to return the complete subscription profile.
   * @summary Retrieves the complete subscription profile registered for the requested member(csid)
   * @param csid
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetCompleteSubscriberProfileResponse>
   */
  getCompleteSubscriberProfile(csid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetCompleteSubscriberProfileResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  getCompleteSubscriberProfile(csid: string, callback: coreHttp.ServiceCallback<Models.CompleteSubscriberProfileApiResponse>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  getCompleteSubscriberProfile(csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.CompleteSubscriberProfileApiResponse>): void;
  getCompleteSubscriberProfile(csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.CompleteSubscriberProfileApiResponse>, callback?: coreHttp.ServiceCallback<Models.CompleteSubscriberProfileApiResponse>): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetCompleteSubscriberProfileResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      getCompleteSubscriberProfileOperationSpec,
      callback) as Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetCompleteSubscriberProfileResponse>;
  }

  /**
   * Relies on SDS and CosmosDB to check for subscriber onboarding status.
   * @summary Retrieves the subscriber onboarding status for the requested member(csid)
   * @param csid
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetSubscriberOnboardingStatusResponse>
   */
  getSubscriberOnboardingStatus(csid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetSubscriberOnboardingStatusResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  getSubscriberOnboardingStatus(csid: string, callback: coreHttp.ServiceCallback<Models.SubscriberOnboardingStatusApiResponse>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  getSubscriberOnboardingStatus(csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.SubscriberOnboardingStatusApiResponse>): void;
  getSubscriberOnboardingStatus(csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.SubscriberOnboardingStatusApiResponse>, callback?: coreHttp.ServiceCallback<Models.SubscriberOnboardingStatusApiResponse>): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetSubscriberOnboardingStatusResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      getSubscriberOnboardingStatusOperationSpec,
      callback) as Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetSubscriberOnboardingStatusResponse>;
  }

  /**
   * Calls external APIs to return the subscription profile.
   * @summary Retrieves the subscription profile registered for the requested member(csid)
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetSubscriberProfileResponse>
   */
  getSubscriberProfile(csid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetSubscriberProfileResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  getSubscriberProfile(csid: string, callback: coreHttp.ServiceCallback<Models.SubscriberProfileApiResponse>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  getSubscriberProfile(csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.SubscriberProfileApiResponse>): void;
  getSubscriberProfile(csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.SubscriberProfileApiResponse>, callback?: coreHttp.ServiceCallback<Models.SubscriberProfileApiResponse>): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetSubscriberProfileResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      getSubscriberProfileOperationSpec,
      callback) as Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetSubscriberProfileResponse>;
  }

  /**
   * Calls external APIs to update the subscriber's data.
   * @summary Updates the requested member(csid) subscription profile.
   * @param csid
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.FamilyIdentityTheftMonitoringSubscriptionUpdateSubscriberProfileResponse>
   */
  updateSubscriberProfile(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionUpdateSubscriberProfileOptionalParams): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionUpdateSubscriberProfileResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  updateSubscriberProfile(csid: string, callback: coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  updateSubscriberProfile(csid: string, options: Models.FamilyIdentityTheftMonitoringSubscriptionUpdateSubscriberProfileOptionalParams, callback: coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>): void;
  updateSubscriberProfile(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionUpdateSubscriberProfileOptionalParams | coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>, callback?: coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionUpdateSubscriberProfileResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      updateSubscriberProfileOperationSpec,
      callback) as Promise<Models.FamilyIdentityTheftMonitoringSubscriptionUpdateSubscriberProfileResponse>;
  }

  /**
   * Updates the requested member(csid) child SSN.
   * @summary Updates the requested member(csid) child SSN
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyIdentityTheftMonitoringSubscriptionUpdateChildSSNResponse>
   */
  updateChildSSN(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionUpdateChildSSNOptionalParams): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionUpdateChildSSNResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  updateChildSSN(csid: string, callback: coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  updateChildSSN(csid: string, options: Models.FamilyIdentityTheftMonitoringSubscriptionUpdateChildSSNOptionalParams, callback: coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>): void;
  updateChildSSN(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionUpdateChildSSNOptionalParams | coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>, callback?: coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionUpdateChildSSNResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      updateChildSSNOperationSpec,
      callback) as Promise<Models.FamilyIdentityTheftMonitoringSubscriptionUpdateChildSSNResponse>;
  }

  /**
   * Calls external APIs to delete the subscriber's cyber data elements.
   * @summary Deletes the requested member(csid) cyber data elements.
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteCyberDataElements(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionDeleteCyberDataElementsOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  deleteCyberDataElements(csid: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteCyberDataElements(csid: string, options: Models.FamilyIdentityTheftMonitoringSubscriptionDeleteCyberDataElementsOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  deleteCyberDataElements(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionDeleteCyberDataElementsOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      deleteCyberDataElementsOperationSpec,
      callback);
  }

  /**
   * Make sds call to delete all verifiable information.
   * @summary Deletes all verifiable information for the requested member(csid)
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteAllVerifiableInfo(csid: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  deleteAllVerifiableInfo(csid: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteAllVerifiableInfo(csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  deleteAllVerifiableInfo(csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      deleteAllVerifiableInfoOperationSpec,
      callback);
  }

  /**
   * Calls external APIs to calculate which data types are registered for CyberAgent monitoring and
   * which are not based on the requested member(csid) complete subscription profile.
   * @summary Calculates CyberAgent monitored and unmonitored data types for the requested
   * member(csid)
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetMonitoredDataTypesResponse>
   */
  getMonitoredDataTypes(csid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetMonitoredDataTypesResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  getMonitoredDataTypes(csid: string, callback: coreHttp.ServiceCallback<Models.GetMonitoredDataTypesApiResponse>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  getMonitoredDataTypes(csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.GetMonitoredDataTypesApiResponse>): void;
  getMonitoredDataTypes(csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.GetMonitoredDataTypesApiResponse>, callback?: coreHttp.ServiceCallback<Models.GetMonitoredDataTypesApiResponse>): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetMonitoredDataTypesResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      getMonitoredDataTypesOperationSpec,
      callback) as Promise<Models.FamilyIdentityTheftMonitoringSubscriptionGetMonitoredDataTypesResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const registerSubscriberOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription",
  urlParameters: [
    Parameters.csid
  ],
  responses: {
    200: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    201: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteSubscriberOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription",
  urlParameters: [
    Parameters.csid
  ],
  queryParameters: [
    Parameters.forceDelete
  ],
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const registerCreditMonitoringSubscriberOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription/Credit/register",
  urlParameters: [
    Parameters.csid
  ],
  responses: {
    200: {
      bodyMapper: Mappers.RegisterCreditMonitoringSubscriberApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const registerSubscriberWithPrimaryDataOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription/register/primary",
  urlParameters: [
    Parameters.csid
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.CsIdPrimaryDataRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    201: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const onboardingCompletedOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription/onboarding/completed",
  urlParameters: [
    Parameters.csid
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getCompleteSubscriberProfileOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription/profile/complete",
  urlParameters: [
    Parameters.csid
  ],
  responses: {
    200: {
      bodyMapper: Mappers.CompleteSubscriberProfileApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getSubscriberOnboardingStatusOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription/profile/onboarding/status",
  urlParameters: [
    Parameters.csid
  ],
  responses: {
    200: {
      bodyMapper: Mappers.SubscriberOnboardingStatusApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getSubscriberProfileOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription/profile",
  urlParameters: [
    Parameters.csid
  ],
  responses: {
    200: {
      bodyMapper: Mappers.SubscriberProfileApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateSubscriberProfileOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription/profile",
  urlParameters: [
    Parameters.csid
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UpdateSubscriberRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.UpdateSubscriberProfileApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateChildSSNOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription/profile/childSSN",
  urlParameters: [
    Parameters.csid
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ChildSSNApiRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.UpdateSubscriberProfileApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteCyberDataElementsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription/profile/cyberdata",
  urlParameters: [
    Parameters.csid
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.DeleteSubscriberCyberDataRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteAllVerifiableInfoOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription/profile/verifiableinfo",
  urlParameters: [
    Parameters.csid
  ],
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getMonitoredDataTypesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/Subscription/profile/cyberdata/types",
  urlParameters: [
    Parameters.csid
  ],
  responses: {
    200: {
      bodyMapper: Mappers.GetMonitoredDataTypesApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
